// import { entriesIn } from 'lodash';
// import Vue from 'vue'
// import Router from 'vue-router'
import {createRouter, createWebHistory} from "vue-router"

import ContestsContestEntriesCreate from '../components/contests/ContestsContestEntriesCreate.vue';
import ContestsContestEntries from '../components/contests/ContestsContestEntries.vue';
import ContestsContestPage from '../components/contests/ContestsContestPage.vue';
import ContestsContestEntriesEntryComplete from '../components/contests/ContestsContestEntriesEntryComplete.vue';
import JudgingFormTotals from "../components/contests/JudgingFormTotals";
import JudgingFormPage from "../components/contests/JudgingFormPage";
import ContestsContestTipsPage from '../components/contests/ContestsContestTipsPage.vue';
import ContestsContestPrizesPage from '../components/contests/ContestsContestPrizesPage.vue';
import ContestsContestRulesPage from '../components/contests/ContestsContestRulesPage.vue';
import ContestsContestThankYouPage from '../components/contests/ContestsContestThankYouPage.vue';
import SuperContestsContestUpdate from '../components/super/SuperContestsContestUpdate.vue';
import SuperContestsCreate from '../components/super/SuperContestsCreate.vue';

// const ContestsContestEntriesEntryComplete = () => import('../components/contests/ContestsContestEntriesEntryComplete.vue');
const ContestsContestEntriesEntry = () => import('../components/contests/ContestsContestEntriesEntry.vue');
// const ContestsContestEntriesCreate = () => import('../components/contests/ContestsContestEntriesCreate.vue');
// const ContestsContestEntries = () => import('../components/contests/ContestsContestEntries.vue');
// const ContestsContestPage = () => import('../components/contests/ContestsContestPage.vue');
const Contests = () => import('../components/contests/Contests.vue');
const SuperContestsContestEntries = () => import('../components/super/SuperContestsContestEntries.vue');
const SuperEntriesEntryUpdate = () => import('../components/super/SuperEntriesEntryUpdate.vue');
const SuperEditUser = () => import('../components/super/SuperEditUser.vue');
const SuperContests = () => import('../components/super/SuperContests.vue');
const SuperContestsContest = () => import('../components/super/SuperContestsContest.vue');
const SuperContestsContestPages = () => import('../components/super/SuperContestsContestPages.vue');
const SuperContestsContestPagesPageUpdate = () => import('../components/super/SuperContestsContestPagesPageUpdate.vue');
const SuperContestsContestPagesCreate = () => import('../components/super/SuperContestsContestPagesCreate.vue');
const SubscriptionsTable = () => import('../components/super/SubscriptionsTable.vue');
const Super = () => import('../components/super/Super.vue');
const createImageWithZip = () => import('../components/super/CreateImageZip.vue');
const ResetPassword = () => import('../components/user/ResetPassword.vue');
const Home = () => import('../components/Home.vue');

// Vue.use(Router)
const routes = [
    {path: '/contests/:contest/entries/:entry/complete', component: ContestsContestEntriesEntryComplete},
    {path: '/contests/:id/entries/create', component: ContestsContestEntriesCreate},
    {path: '/contests/:contest_id/entries/:id', component: ContestsContestEntriesEntry},
    {path: '/contests/:contest/:id/entries', component: ContestsContestEntries},
    {path: '/contests/:id/entries', component: ContestsContestEntries},
    {path: '/contests/:id/finalists', component: ContestsContestEntries},
    {path: '/contests/:id/rules', component: ContestsContestRulesPage},
    {path: '/contests/:contest_id/about', component: ContestsContestPage},
    {path: '/contests/:contest_id/help', component: ContestsContestTipsPage},
    {path: '/contests/:contest_id/prizes', component: ContestsContestPrizesPage},
    {path: '/contests/:contest_id/purchase-complete', component: ContestsContestThankYouPage},
    {path: '/contests/:contest/judging-form', component: JudgingFormPage},
    {path: '/contests/:contest/judging-totals', component: JudgingFormTotals},
    {path: '/contests/createimagewithzip', component: createImageWithZip},
    {path: '/contests', component: Contests},
    {path: '/super/contests/:contest/entries', component: SuperContestsContestEntries},
    {path: '/super/entries/:id', component: SuperEntriesEntryUpdate},
    {path: '/super/users/:id', component: SuperEditUser},
    {path: '/super/contests', component: SuperContests},
    {path: '/super/contests/create', component: SuperContestsCreate},
    {path: '/super/contests/:contest', component: SuperContestsContest},
    {path: '/super/contests/:contest/subscriptions-table', component: SubscriptionsTable},
    {path: '/super/contests/:contest/subscriptions-table/:product', component: SubscriptionsTable},
    {path: '/super/contests/:contest/purchases-table', component: SubscriptionsTable},
    {path: '/super/contests/:contest/purchases-table/:product', component: SubscriptionsTable},
    {path: '/super/contests/:contest/update', component: SuperContestsContestUpdate},
    {path: '/super/contests/:contest/pages/create', component: SuperContestsContestPagesCreate},
    {path: '/super/contests/:contest/pages/:id/update', component: SuperContestsContestPagesPageUpdate},
    {path: '/super/contests/:contest/pages', component: SuperContestsContestPages},
    {path: '/super', component: Super},
    {path: '/user/reset_password/:token', component: ResetPassword},
    {path: '/', component: Home},

]
const router = createRouter({
    history: createWebHistory(),
    routes: routes
})
export default router;